<button class="btn-link groovy-btn no-padding margin-left" [rlAria]="'general.back' | translate" id="back-btn" (click)="onClick.emit()" type="button" [rlAria] [rlTabIndex]>
    <i class="fa fa-chevron-left"></i>
    {{'general.back' | translate}}
</button>